module.exports = __webpack_public_path__ + "img/ok.b774c467.png";